import { Resource as a } from "@coveo/platform-client";
const t = class t extends a {
  /**
   * Returns a list of reports for the specified project.
   *
   * @param {string} projectId ID of the project for which to retrieve reports.
   * @param {ListReportsOptions} options Options to customize the list of reports.
   * @returns {Promise<ListReportsResponse>} List of reports for the specified project.
   */
  listReportsByProjectId(i, r = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/list`, {
        ...r,
        org: this.api.organizationId,
        projectId: i
      })
    );
  }
};
t.baseUrl = "/rest/ua/v15/reports";
let s = t;
export {
  s as ReportInternalResource
};
//# sourceMappingURL=ReportInternalResource.js.map
